import { curry, constructor } from 'ramda';
import { promisify } from 'bluebird';
import JSZip from 'jszip';

let getBinaryContent = null;
if (typeof window !== 'undefined') {
  const jszipUtils = require('jszip-utils');
  getBinaryContent = promisify(jszipUtils.getBinaryContent.bind(jszipUtils));
}

export default curry((powerPointUrl, replaces, slideNums) => {
  if (typeof slideNums === 'number') {
    slideNums = [slideNums];
  }

  replaces.swaps = replaces.swaps || {};

  const zip = new JSZip();
  return getBinaryContent(powerPointUrl)
  .then(zip.loadAsync.bind(zip))
  .then((zip) => {

    const promises = slideNums.map((slideNum) => {
      return zip.folder('ppt').folder('slides').file(`slide${slideNum}.xml`)
      .async('string').then((text) => {

        for (let key of Object.keys(replaces.text)) {
          text = text.replace('{{' + key + '}}', replaces.text[key]);
        }

        zip.folder('ppt').folder('slides').file(`slide${slideNum}.xml`, text);
      });
    });

    return Promise.all(promises).then(() => {
      const mediaFolder = zip.folder('ppt').folder('media');
      for (let key of Object.keys(replaces.images)) {
        mediaFolder.file(key, replaces.images[key], { base64: true });
      }

      var pr = [];
      for (let key of Object.keys(replaces.swaps)) {
        pr.push(mediaFolder.file(replaces.swaps[key]).async('base64').then((data) => { mediaFolder.file(key, data, { base64: true }) }));
      }

      return Promise.all(pr).then(() => zip.generateAsync({ type: 'blob' }));
    });
  });

});



// WEBPACK FOOTER //
// ./src/modules/powerpointReplace.js